<div class="ok" *ngIf="paymentSuccess">
    <div class="ok__head">
        <span class="ok__disc" aria-hidden="true">
            <vb-icon name="check" [size]="18" [strokeWidth]="2.5"></vb-icon>
        </span>
        <h2 class="ok__title">{{ successTitle }}</h2>
    </div>

    <p class="ok__body">
        You can close this window. We've emailed a confirmation and a copy of
        your invoice to
        <strong>{{ invoiceDetails?.buyer?.email }}</strong>.
    </p>

    <div class="ok__summary">
        <span class="ok__eyebrow">Order summary</span>

        <div class="ok__row" *ngIf="isPickupBranch && !scheduleLater">
            <span class="ok__label">
                {{
                    selectedDeliveryMethod === 'pickup'
                        ? 'Pickup'
                        : 'Self-service pickup'
                }}
            </span>
            <span class="ok__value">
                {{ selectedDate | vbDate }}
                {{ selectedSlot?.slotLabel }} {{ selectedSlot?.zone }}
            </span>
        </div>

        <div
            class="ok__row"
            *ngIf="selectedDeliveryMethod === 'proxyPickup' && !scheduleLater">
            <span class="ok__label">Picked up by</span>
            <span class="ok__value">{{ proxyName }} · {{ proxyTelephone }}</span>
        </div>

        <div
            class="ok__row"
            *ngIf="selectedDeliveryMethod === 'shipping' && !scheduleLater">
            <span class="ok__label">Shipping to</span>
            <span class="ok__value">{{ shipLine }}</span>
        </div>

        <div class="ok__row" *ngIf="!isPaidInFull">
            <span class="ok__label">Payment</span>
            <span class="ok__value ok__value--num">
                <ng-container *ngIf="selectedPaymentCard">
                    {{ selectedPaymentCard.cardNumber }} ·
                </ng-container>
                <ng-container *ngIf="isPayOnPickup">Pay on pickup ·</ng-container>
                ${{ invoiceDetails?.invoice?.amountDue | number: '1.2-2' }}
            </span>
        </div>
    </div>

    <vb-banner tone="info" class="ok__note" *ngIf="scheduleLater">
        Paying now with pickup later gives you the freedom to schedule when
        it's convenient. Open <strong>My invoices</strong> to book your pickup
        slot.
    </vb-banner>

    <p
        class="ok__idnote"
        *ngIf="selectedDeliveryMethod === 'proxyPickup' && !scheduleLater">
        Whoever collects the order must bring a copy of this invoice and
        government-issued photo ID.
    </p>

    <div class="ok__actions">
        <vb-button variant="secondary" (clicked)="goBack()">
            View my invoices
        </vb-button>
        <vb-button variant="primary" (clicked)="goToAllAuctions()">
            Browse auctions
        </vb-button>
    </div>
</div>
